export default (function (theme) {
  return {
    root: {
      height: 20
    },
    disabledOn: {
      '& div': {
        '& .react-switch-bg': {
          backgroundColor: "".concat(theme.colors.orange200, "!important")
        }
      }
    },
    disabledOff: {
      '& div': {
        '& .react-switch-bg': {
          backgroundColor: "".concat(theme.colors.neutral500, "!important")
        }
      }
    }
  };
});